const TYPES = {
    UPDATE_USER_TOKEN : 'UPDATE_USER_TOKEN'
}

export default TYPES
